import React from 'react';
import { Check, Zap } from 'lucide-react';

const Plans = () => {
  const plans = [
    {
      id: 'free',
      name: 'FREE',
      price: 'Grátis',
      description: 'Ideal para começar agora.',
      features: [
        'Acesso ao repositório privado',
        'Upload e download de materiais',
        'Planejamento básico de aulas',
      ],
      color: 'green',
      status: 'available',
      buttonText: 'Disponível agora'
    },
    {
      id: 'pro',
      name: 'PRO',
      price: 'Em breve',
      description: 'Ideal para quem quer ganhar tempo de verdade.',
      features: [
        'Acesso ao repositório privado',
        'Acesso ao repositório público',
        'Downloads ilimitados',
        'Planejamento avançado por período',
        'Organização por turmas',
        'Favoritar materiais',
        'Suporte prioritário'
      ],
      color: 'blue',
      status: 'soon',
      buttonText: 'Ver detalhes'
    },
    {
      id: 'elite',
      name: 'ELITE',
      price: 'Em breve',
      description: 'Para quem quer ir além da sala de aula.',
      features: [
        'Tudo do PRO',
        'Materiais exclusivos e curados',
        'Planos de aula prontos por série',
        'Ferramentas de personalização',
        'Participação em decisões do produto',
        'Destaque como professor colaborador'
      ],
      color: 'purple',
      status: 'soon',
      buttonText: 'Ver detalhes'
    }
  ];

  return (
    <section id="planos" className="py-24 bg-gray-50 bg-grid">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-sm font-bold text-purple-600 uppercase tracking-widest mb-4 block">💳 Planos</span>
          <h2 className="font-hero text-4xl md:text-5xl mb-6">Comece grátis — evolua quando quiser</h2>
          <p className="text-lg text-gray-600">
            Durante o lançamento, o Sôra é gratuito para todos. <br className="hidden md:block" />
            Em breve, novos planos estarão disponíveis.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`relative bg-white p-10 rounded-[3rem] shadow-lg border-2 ${plan.id === 'free' ? 'border-green-500 ring-8 ring-green-50' : 'border-transparent'
                } flex flex-col h-full overflow-hidden`}
            >
              {plan.status === 'soon' && (
                <div className="absolute top-4 right-4 bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold">
                  Em Breve
                </div>
              )}
              {plan.id === 'free' && (
                <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
                  <Zap size={12} fill="currentColor" /> Ativo
                </div>
              )}

              <div className="mb-8">
                <h3 className={`text-2xl font-black mb-2 ${plan.color === 'green' ? 'text-green-600' :
                  plan.color === 'blue' ? 'text-blue-600' : 'text-purple-600'
                  }`}>
                  {plan.name}
                </h3>
                <div className="text-4xl font-black mb-4">{plan.price}</div>
                <p className="text-gray-500 font-medium">{plan.description}</p>
              </div>

              <div className="space-y-4 mb-10 flex-grow">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className="mt-1 bg-gray-100 rounded-full p-0.5">
                      <Check size={16} className="text-gray-600" />
                    </div>
                    <span className="text-gray-700 leading-tight">{feature}</span>
                  </div>
                ))}
              </div>

              <button className={`w-full py-4 px-6 rounded-full font-bold text-lg transition-all active:scale-95 ${plan.status === 'available'
                ? 'bg-black text-white hover:bg-gray-800 shadow-xl'
                : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                }`}>
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Plans;

